//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PayrollType, PayrollSourceType } from './Enums';

export class PayrollSearchOptions extends ItemBase {
    Amount: number | null = null;
    MaxDate: string | null = null;
    MinDate: string | null = null;
    PayrollTypes: PayrollType[] = [];
    Sources: PayrollSourceType[] = [];
    SearchText: string | null = null;
    IDs: string[] = [];
    TeacherIDs: string[] = [];
    CashIDs: string[] = [];
    StudentIDs: string[] = [];

    constructor(initializer?: Partial<PayrollSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PayrollSearchOptions";
}
